"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("./bootstrap-icons");
